export default function Pricing() {
  const plans = [
    {
      name: 'FREE',
      subtitle: 'Forever',
      price: null,
      bgColor: 'bg-blue-50',
      features: [
        'List up to 10 items',
        'Basic search & filters',
        'In-app messaging',
        'Community access',
        'Trust & safety features'
      ],
      buttonText: 'Get Started',
      buttonStyle: 'border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white',
      popular: false
    },
    {
      name: '$4.99',
      subtitle: 'Premium Swapper',
      price: '/mo',
      bgColor: 'bg-orange-100',
      features: [
        'Unlimited item listings',
        'Priority in search results',
        'Advanced filters & alerts',
        'Featured listings (2/month)',
        'Early access to new features',
        'Ad-free experience',
        'Premium badge'
      ],
      buttonText: 'Upgrade Now',
      buttonStyle: 'bg-white text-gray-900 hover:bg-gray-50',
      popular: true
    },
    {
      name: 'Custom',
      subtitle: 'For Organizations',
      price: null,
      bgColor: 'bg-purple-50',
      features: [
        'Dedicated account manager',
        'Custom branding options',
        'Bulk listing tools',
        'Analytics dashboard',
        'API access',
        'Priority support'
      ],
      buttonText: 'Contact Us',
      buttonStyle: 'border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white',
      popular: false
    }
  ];

  return (
    <section id="pricing" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-4 py-1.5 rounded-full text-xs font-semibold tracking-wider uppercase mb-4">
            Pricing & Plans
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-2">
            Choose Your
          </h2>
          <h2 className="text-5xl md:text-6xl font-serif italic text-gray-900 mb-4">
            Swap Style
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Start for free or upgrade for premium features and priority access
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div key={index} className={`${plan.bgColor} rounded-3xl p-8 relative hover:shadow-2xl transition-all duration-300`}>
              {plan.popular && (
                <div className="absolute top-6 right-6 bg-teal-600 text-white px-3 py-1 rounded-full text-xs font-bold whitespace-nowrap">
                  MOST POPULAR
                </div>
              )}

              <div className="absolute top-6 right-6">
                <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-transform">
                  <i className="ri-arrow-right-up-line text-gray-900 text-lg"></i>
                </div>
              </div>

              <div className="mb-8">
                <div className="text-5xl font-serif font-bold text-gray-900 mb-1">
                  {plan.name}
                  {plan.price && <span className="text-2xl">{plan.price}</span>}
                </div>
                <div className="text-gray-600 font-medium">{plan.subtitle}</div>
              </div>

              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                    <span className="text-gray-700 text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              <button className={`w-full py-4 rounded-full font-semibold transition-all ${plan.buttonStyle} whitespace-nowrap`}>
                {plan.buttonText}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
